

import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { EleWorkSubTypeDDLAPI, EleWorkTypeDDLAPI, WorkTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const ElEWorkSubTypeDDL = (props) => {
    const { WorkType, WorkSubType,setWorkSubType, rowData, Flag, IsPost, IsDisabled, ApiFlag, ActiveBtn, isDisplay } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_ELEC_WorkTypeID : WorkType?.ID,
            Flag: ApiFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(EleWorkSubTypeDDLAPI({ data }))
    }, [IsPost && IsPost, WorkType?.ID])

    const { WorkTypeData } = useSelector(state => state.EleWorkSubTypeDDLData)


    useEffect(() => {
        handleWorkTypeDDL()
    }, [WorkTypeData])

    const handleWorkTypeDDL = () => {
        if (WorkTypeData && WorkTypeData.table && WorkTypeData.table.length > 0) {
            let list = WorkTypeData.table.map((item, index) => ({
                value: item.m_eleC_WorkSubTypeID,
                label: item.workSubTypeName,
            }))

            setWorkSubType({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_eleC_WorkSubTypeID : 0,
                Label: Flag === 'Update' ? rowData.workSubTypeName : "Select ...",
            })

        }
        else {
            setWorkSubType({
                DDL: [],
                ID: 0,
                Label: "Select ...",
            })
        }

    }

    return (
        <div className="form-group">
            {
                (isDisplay && isDisplay == true) &&
                <label className="d-block" htmlFor="NameofWorkType"><b>Work Sub Type {Flag && <AstricSign />} </b></label>
            }
            <Select
                isClearable
                // isRtl={isRtl}
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                className=""
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkSubType.ID, label: WorkSubType.Label }}
                onChange={(e) => {
                    e ?
                        setWorkSubType({ ...WorkSubType, ID: e.value, Label: e.label })
                        :
                        setWorkSubType({ ...WorkSubType, ID: 0, Label: "Select WorkSubType" })
                }}
                options={WorkSubType.DDL}
            />
        </div>
    )
}